/*global Modernizr, aplusfcu_map_styles, google, SVGMarker, InfoBox, default_map_locations, location_atm_tooltip, location_branch_tooltip */
/*jslint browser:true */

(function() {
  'use strict';

  var map_container = document.querySelector('.locations-search-map'),
      map_markers = [],
      map,
      bounds;

  if(map_container) {
    map = new google.maps.Map(map_container, {
      zoom: 15,
      maxZoom: 17,
      center: new google.maps.LatLng(30.266666, -97.733330),
      mapTypeControl: false,
      panControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      scaleControl: false,
      scrollwheel: false,
      styles: aplusfcu_map_styles
    });

    map_container.addEventListener('view-updated', () => {
      setTimeout(() => map.fitBounds(bounds), 100);
    });

    map_container.addEventListener('load-locations', (e) => {
      process_locations(e.detail.locations);
    });

    if(default_map_locations) {
      process_locations(default_map_locations);
    }
  }

  function process_locations(locations) {
    bounds = new google.maps.LatLngBounds();

    map_markers.forEach((map_marker) => {
      map_marker.infobox.close();
      map_marker.setMap(null);
    });

    map_markers = [];

    locations.forEach((location) => {
      var marker_content = convertToDom('<div class="markers"><img src="/wp-content/themes/aplusfcu/images/dist/icons/map-pin_' + location.type + '-gray.svg" class="gray"><img src="/wp-content/themes/aplusfcu/images/dist/icons/map-pin_' + location.type + '.svg" class="clicked"></div>');

      var marker_position = new google.maps.LatLng(location.latitude, location.longitude),
          marker = new SVGMarker({
            position: marker_position,
            map: map,
            clickable: true,
            icon: {
              size: new google.maps.Size(42, 52),
              anchor: new google.maps.Point(21, 42),
              url: '/wp-content/themes/aplusfcu/images/dist/icons/map-pin_' + location.type + '.svg', // This one is not shown so we can animate it
              class: 'SVGMarker',
              html: marker_content
            }
          });

      bounds.extend(marker_position);

      var infobox_content;

      if(!location.is_closed) {
        location.closed = ' hidden';
      } else {
        location.closed = '';
      }

      if(location.type === 'atm') {
        infobox_content = location_atm_tooltip(location);
      } else {
        infobox_content = location_branch_tooltip(location);
      }

      infobox_content = convertToDom(infobox_content);

      infobox_content.querySelector('.close').addEventListener('click', (e) => {
        e.preventDefault();

        marker.container.classList.remove('infobox-open');
        infobox.close();
      });

      var window_width = document.body.offsetWidth,
          infobox_width = (window_width > 750)?450:345,
          infobox = new InfoBox({
            content: infobox_content,
            pixelOffset: new google.maps.Size(((infobox_width / 2) * -1), -65),
            alignBottom: true,
            position: marker_position,
            boxStyle: {
              width: infobox_width + 'px'
            },
            closeBoxURL: '',
            infoBoxClearance: new google.maps.Size(10, 10),
          });

      marker.infobox = infobox;

      google.maps.event.addListener(marker, 'click', () => {
        if(infobox.getVisible()) {
          marker.container.classList.remove('infobox-open');
          infobox.close();
        } else {
          map_markers.forEach((map_marker) => {
            map_marker.container.classList.remove('infobox-open');
            map_marker.infobox.close();
          });

          marker.container.classList.add('infobox-open');
          infobox.open(map);
        }
      });

      map_markers.push(marker);
    });

    map.fitBounds(bounds);
  }

  function convertToDom(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    return d.firstChild;
  }
}());
